import { isProduction } from "./envUtils";

const genericCardImg = require("img/generic-card.png");

const bluesnapProduction = "https://pay.bluesnap.com";
const bluesnapSandbox = "https://sandpay.bluesnap.com";

const bluesnapDomainPath = isProduction() ? bluesnapProduction : bluesnapSandbox;

let bluesnapConfigured = false;

export function configureBluesnapIfNeeded() {
    if (!bluesnapConfigured) {
        const scriptTag = document.createElement("script");
        scriptTag.type = "text/javascript";
        scriptTag.src = bluesnapDomainPath + "/web-sdk/5/bluesnap.js";

        document.body.appendChild(scriptTag);
        bluesnapConfigured = true;
    }
}

const cardTypeToImageMap = {
    AMEX: "amex.png",
    DINERS: "diners.png",
    DISCOVER: "discover.png",
    JCB: "jcb.png",
    MaestroUK: "maestro.png",
    MASTERCARD: "mastercard.png",
    VISA: "visa.png",
    Solo: "solo.png",
    CarteBleue: "cb.png",
};

export function getCardIconUrl(cardType: string) {
    if (!cardType) {
        return genericCardImg;
    }
    const baseUrl = bluesnapDomainPath + "/source/web-sdk/hosted-payment-fields/cc-types/";
    const fileName = cardTypeToImageMap[cardType];
    if (!fileName) {
        return genericCardImg;
    }

    return baseUrl + fileName;
}
